module.exports = __webpack_public_path__ + "assets/icons/http-24px.svg";